import { useQuery } from '@tanstack/react-query';

import { ApplicationConfig } from '@repo/sdk/models/components';

import { APP_CONFIG_KEY } from '@/constants';
import { queryClient } from '@/singletons';

/**
 * Hook to access the application configuration that was fetched during bootstrap.
 * The config is prefetched in main.tsx before the app renders.
 */
export const useAppConfig = () => {
  return useQuery<ApplicationConfig>({
    queryKey: [APP_CONFIG_KEY],
    // This should never actually run since data is prefetched
    queryFn: () => {
      const cachedData = queryClient.getQueryData<ApplicationConfig>([APP_CONFIG_KEY]);
      if (!cachedData) {
        console.warn(
          'App config not found in cache. This should never happen in normal operation.'
        );
        throw new Error('Application configuration not available');
      }
      return cachedData;
    },
    // Use the data that was prefetched in main.tsx
    initialData: () => queryClient.getQueryData<ApplicationConfig>([APP_CONFIG_KEY]),
    staleTime: Infinity, // Config is static for the app's lifetime
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
